import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { v4 } from '@lukeed/uuid';
import { Field, useFormikContext } from 'formik';
import { FaLink, FaPlus, FaTimes } from 'react-icons/fa';
import Button from '../../../elements/Button';
import { GroupPane } from '../../../elements/GroupPane';
import FormikCheckBox from '../../../elements/formik/FormikCheckBox';
import FormikInput from '../../../elements/formik/FormikInput';
import { getPreferencesByWorkspace } from '../../../reducer/preferences/utilities/getPreferencesByWorkspace';
import { isGoogleDocument } from '../../../utility/isGoogleDocument';
const style = {
    table: {
        width: '100%',
    },
    th: {
        fontSize: '12px',
    },
    input: {
        width: '100%',
    },
    labelCol: {
        width: '30%',
    },
    serialCol: {
        width: '5%',
    },
    checkbox: {
        display: 'block',
        margin: '0 auto',
        width: 'fit-content',
    },
};
function DatabasesTabContent({ currentWorkspace, originalWorkspaces, }) {
    const { values, setFieldValue } = useFormikContext();
    const databases = values.databases;
    function deleteHandler(index) {
        const _database = databases.data.slice();
        _database.splice(index, 1);
        setFieldValue('databases.data', _database);
    }
    function addHandler() {
        const newDatabase = {
            key: v4(),
            label: '',
            url: '',
            enabled: true,
        };
        setFieldValue('databases.data', [...databases.data, newDatabase]);
    }
    function resetHandler() {
        const workSpaceDisplayPreferences = getPreferencesByWorkspace(currentWorkspace, originalWorkspaces);
        const database = workSpaceDisplayPreferences.databases.data;
        setFieldValue('databases.data', database);
    }
    return (_jsx("fieldset", { onClick: (e) => {
            if (e.target.checked) {
                e.target.checked = false;
                setFieldValue('databases.defaultDatabase', '');
            }
        }, children: _jsx(GroupPane, { text: "Databases", renderHeader: (text) => {
                return (_jsx(DataBaseHeader, { text: text, onReset: resetHandler, onAdd: addHandler }));
            }, children: _jsxs("table", { style: style.table, children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { style: style.th, children: "#" }), _jsx("th", { style: style.th, children: "Label " }), _jsx("th", { style: style.th, children: "URL" }), _jsx("th", { style: style.th, children: "Enabled" }), _jsx("th", { style: style.th, children: "Auto Load" }), _jsx("th", {})] }) }), _jsx("tbody", { children: databases?.data.map((item, index) => {
                            const num = index + 1;
                            return (
                            // eslint-disable-next-line react/no-array-index-key
                            _jsxs("tr", { style: { height: '33px' }, children: [_jsxs("td", { style: style.serialCol, children: [_jsx("span", { children: num }), ' '] }), _jsx("td", { style: style.labelCol, children: _jsx(FormikInput, { style: { input: style.input }, name: `databases.data.${index}.label`, checkErrorAfterInputTouched: false }) }), _jsx("td", { children: _jsx(FormikInput, { style: { input: style.input }, name: `databases.data.${index}.url`, checkErrorAfterInputTouched: false }) }), _jsx("td", { children: _jsx(FormikCheckBox, { style: {
                                                container: style.checkbox,
                                            }, className: "checkbox-element", name: `databases.data.${index}.enabled` }) }), _jsx("td", { children: _jsx(Field, { style: style.checkbox, type: "radio", name: "databases.defaultDatabase", value: item.key }) }), _jsx("td", { children: _jsxs("div", { style: {
                                                display: 'flex',
                                                height: '100%',
                                            }, children: [_jsx(Button.Danger, { style: { fontSize: '14px' }, fill: "clear", onClick: () => deleteHandler(index), children: _jsx(FaTimes, {}) }), databases.length === index + 1 && (_jsx(Button.Done, { fill: "clear", style: { fontSize: '14px' }, onClick: addHandler, children: _jsx(FaPlus, {}) })), isGoogleDocument(item.url) && (_jsx(Button.Action, { style: { fontSize: '13px' }, fill: "clear", onClick: () => window.open(item.url, '_blank'), children: _jsx(FaLink, {}) }))] }) })] }, `${index}`));
                        }) })] }) }) }));
}
function DataBaseHeader({ onReset, onAdd, text }) {
    return (_jsxs("div", { className: "section-header", style: { display: 'flex' }, children: [_jsx("p", { style: { flex: 1 }, children: text }), _jsxs("div", { style: { display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Button.Danger, { fill: "clear", size: "xSmall", onClick: onReset, style: { margin: '0 5px' }, children: "Reset Databases" }), _jsx(Button.Done, { fill: "outline", size: "xSmall", onClick: onAdd, children: "Add Database" })] })] }));
}
export default DatabasesTabContent;
